import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import React, { lazy, PropsWithChildren, Suspense } from "react";
import { PageModuleStructure } from "../config/page";
import { loadModule } from "./webpack-loader";
export interface RenderModuleProps extends PageModuleStructure{
  container?: Node
}

export const RenderModule = ({
  url,
  module,
  scope,
  children,
  container
}: PropsWithChildren<RenderModuleProps>) => {
  const cache = createCache({
    key:scope,  
    container,
  })
  const LazyModule = lazy(() => loadModule(url, scope, module));
  return (
    <CacheProvider value={cache}>
      <Suspense fallback={<>{children}</>}>
        <LazyModule />
      </Suspense>
    </CacheProvider>
  );
};
